import { ERoleIsSystem } from '../../enum'

// Create a union type of all possible values from the enum
type IRoleIsSystemLangKey = `${ERoleIsSystem}`

export type IRoleIsSystemLang = {
	role_is_system: Record<IRoleIsSystemLangKey, string>
}

const langEntries = Object.entries(ERoleIsSystem).map(
	([key, value]) => [value, `role_is_system.${value}`]
)

const langObj: Record<IRoleIsSystemLangKey, string> = Object.fromEntries(langEntries)

export const ROLE_IS_SYSTEM_LANG_KEY: IRoleIsSystemLang = {
	role_is_system: langObj
}
